import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AllStaff } from '../models/AllStaff';

@Injectable({
  providedIn: 'root'
})
export class StaffModuleManagementService {

  public updateStaffTable: Subject<boolean> = new Subject();
  public updateRow: Subject<AllStaff> = new Subject();
  public cleared: Subject<boolean> = new Subject();
  public profileClicked: Subject<AllStaff> = new Subject();
  public totalStaffNumber: Subject<number> = new Subject();

  constructor() { }

  getUpdatedRow(): Observable<AllStaff> {
    return this.updateRow.asObservable();
  }

  getTotalStaffMembersNumber(): Observable<number> {
    return this.totalStaffNumber.asObservable();
  }

  getClickedProfile(): Observable<AllStaff> {
    return this.profileClicked.asObservable();
  }

  clearAll(): Observable<boolean> {
    return this.cleared.asObservable();
  }

}
